module.exports = __webpack_public_path__ + "img/male-teacher.4db31ded.png";